import React from 'react';

const CameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.446 4.74394L16.4459 4.74411L15.2625 5.91131V5.6875C15.2625 4.64494 14.4169 3.8 13.375 3.8H2.6875C1.64671 3.8 0.8 4.64606 0.8 5.6875V9.60925V14.6875C0.8 15.7294 1.64494 16.575 2.6875 16.575H13.375C14.417 16.575 15.2625 15.7295 15.2625 14.6875V14.4789L16.4459 15.6461L16.446 15.6462C16.6942 15.8905 17.028 16.0277 17.3761 16.0277H17.875C18.6064 16.0277 19.2 15.4348 19.2 14.7027V5.6875C19.2 4.95542 18.6064 4.3625 17.875 4.3625H17.3761C17.028 4.3625 16.6942 4.49972 16.446 4.74394ZM17.3953 14.5027L15.2625 12.3698V12.3547L15.2039 12.2961L14.7 11.7922V8.58284L17.3953 5.8875H17.675V14.5027H17.3953ZM2.6875 15.05C2.48759 15.05 2.325 14.8871 2.325 14.6875V5.6875C2.325 5.48689 2.48689 5.325 2.6875 5.325H13.375C13.5746 5.325 13.7375 5.48759 13.7375 5.6875V14.6875C13.7375 14.887 13.5745 15.05 13.375 15.05H2.6875Z"
      strokeWidth="0.4"
    />
    <line x1="15" y1="7" x2="15" y2="13" />
  </svg>
);

export default CameraIcon;
